import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-services',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './services.component.html',
  styleUrl: './services.component.scss'
})
export class ServicesComponent {
  services = [
    {
      id: 1,
      slug: 'residential-construction',
      title: 'Residential Construction',
      description: 'Premium residential projects from concept to completion, crafted with attention to every detail.',
      icon: 'home',
      features: ['Custom Design', 'Quality Materials', 'Expert Craftsmanship']
    },
    {
      id: 2,
      slug: 'commercial-construction',
      title: 'Commercial Construction',
      description: 'Modern commercial spaces designed for businesses to thrive and scale.',
      icon: 'building',
      features: ['Business-Focused', 'Future-Ready', 'Cost-Effective']
    },
    {
      id: 3,
      slug: 'infrastructure-development',
      title: 'Infrastructure Development',
      description: 'Large-scale infrastructure projects with precision and sustainability.',
      icon: 'bridge',
      features: ['Sustainable', 'Scalable', 'Innovative']
    },
    {
      id: 4,
      slug: 'interior-design-finishing',
      title: 'Interior Design & Finishing',
      description: 'Stunning interiors that combine aesthetics with functionality.',
      icon: 'palette',
      features: ['Design-Focused', 'Modern', 'Customizable']
    },
    {
      id: 5,
      slug: 'renovation-remodeling',
      title: 'Renovation & Remodeling',
      description: 'Transform existing spaces with modern upgrades and improvements.',
      icon: 'refresh',
      features: ['Modernization', 'Minimal Disruption', 'Value-Add']
    },
    {
      id: 6,
      slug: 'project-management',
      title: 'Project Management',
      description: 'Expert oversight ensuring projects stay on schedule and budget.',
      icon: 'chart',
      features: ['Timeline Control', 'Budget Management', 'Quality Oversight']
    },
  ];
}
